import { useEffect, useRef } from 'react';

// Returns the value from the previous render, letting an effect detect a
// transition (e.g. authenticated -> de-authenticated). Web equivalent of the
// mobile app/src/hooks/usePrevious.js.
export default function usePrevious(value) {
  const ref = useRef();

  // The effect runs after render, so reads during render see the prior value.
  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
